import React, { useState, useEffect, useContext } from "react";
import "../../styles/global.css";
import {
  Paper,
  Toolbar,
  InputAdornment,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import Controls from "../../components/controls/Controls";
import Axios from "axios";
import useTable from "../../components/useTable";
import { Search } from "@material-ui/icons";
import DetailProduct from "./detail";
import WarningIcon from "@material-ui/icons/Warning";
import ProductCompletion from "../management/completion";
import ProductDeletion from "../management/deletion";
import { baseUrl } from "../../config/const";
import ArchiveProduct from "../management/archiveProduct";
import { AuthContext } from "../../AppContext";

export default function IncompleteProducts() {
  const { state, dispatch } = useContext(AuthContext);
  const headCells = [
    { id: "sku", label: "SKU", disableSorting: true },
    { id: "brand", label: "Brand" },
    { id: "pname", label: "Product Name", disableSorting: true },
    { id: "color", label: "Color", disableSorting: true },
    { id: "department", label: "Department", disableSorting: true },
    { id: "price1", label: "Price 1" },
    { id: "price2", label: "Price 2" },
    { id: "status", label: "Status", disableSorting: true },
    { id: "actions", label: "Actions", disableSorting: true },
  ];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    location: "",
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState({
    isOpen: false,
    title: "",
    subtitle: "",
  });
  const [detailItem, setDetailItem] = useState({});

  /**
   * return results of useForm helper method
   * @param records are the data from db
   * @param headCells header of the table
   * @param filterFn filtering function that carries the records
   */
  const { TblHead, TblContainer, TblPagination, recordsAfterPagingAndSorting } =
    useTable(state.incompleteProductList, headCells, filterFn);

  /**
   * @returns records of all products
   */
  const getIncompleteProducts = async () => {
    await Axios.get(`${baseUrl}/getIncompleteProducts`)
      .then((response) => {
        dispatch({
          type: "UPDATE_LIST",
          payload: {
            incompleteProductList: response.data.records,
          },
        });
      })
      .catch((err) => {
        setNotify({
          message: "error",
          isOpen: true,
          type: "error",
        });
      });
  };
  /**
   *
   * @param {*} e indicates the search event
   */
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => x.sku.includes(target.value));
        }
      },
    });
  };
  useEffect(() => {
    getIncompleteProducts();
  }, []);

  return (
    <div className="incomplete-product">
      <h1>Incomplete Product List</h1>
      <Paper elevation={2}>
        <Toolbar>
          <Controls.Label label="Search: " />
          <Controls.Input
            inputprops={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={handleSearch}
            placeholder="CARI KODE BARCODE..."
          />
        </Toolbar>
        <TblContainer>
          <TblHead />
          <TableBody>
            {recordsAfterPagingAndSorting().map((item) => (
              <TableRow key={item.sku} hover role="checkbox" tabIndex={-1}>
                <TableCell
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setOpenPopup(true);
                    setDetailItem(item);
                  }}
                >
                  {item.sku}
                </TableCell>
                <TableCell>{item.brand}</TableCell>
                <TableCell>{item.pname}</TableCell>
                <TableCell>{item.color}</TableCell>
                <TableCell>{item.department}</TableCell>
                <TableCell>Rp {item.price1}</TableCell>
                <TableCell>Rp {item.price2}</TableCell>
                <TableCell style={{ color: "red" }}>
                  <WarningIcon fontSize="small" />
                  {item.status}
                </TableCell>
                <TableCell>
                  <ProductCompletion
                    item={item}
                    location="/products/incompleteProducts"
                  />
                  {/* <ArchiveProduct
                                    param={item.sku}
                                    location="/products/incompleteProducts" /> */}
                  <ProductDeletion
                    productStatus="incomplete"
                    param={item.sku}
                    location="/products/incompleteProducts"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TblContainer>
        <TblPagination />
      </Paper>

      <Controls.Popup
        title="Product Detail"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <DetailProduct item={detailItem} />
      </Controls.Popup>

      <Controls.Notification notify={notify} setNotify={setNotify} />

      <Controls.ConfirmPopup
        confirmPopup={confirmPopup}
        setConfirmPopup={setConfirmPopup}
      />
    </div>
  );
}
